import React, { useEffect, useRef, useState } from 'react';
import { Button, FormControl, Form, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { PHP } from '../../utils/axiosConfig';
import FileUploadModal from './FileUploadModal';

function FileUpload({ useModal, callback, selectedUser }) {
	const php = PHP();
	const [selectedFile, setSelectedFile] = useState(null);
	const [selectedFileName, setSelectedFileName] = useState('');
	const [uploadSuccess, setUploadSuccess] = useState(false);
	const [uploadFailure, setUploadFailure] = useState(false);
	const fileRef = useRef(null);
	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		if (uploadSuccess || uploadFailure) {
			setSelectedFileName('');
			setSelectedFile(null);
			setShowModal(false);
			callback();
			const timer = setTimeout(() => {
				setUploadSuccess(false);
				setUploadFailure(false);
			}, [2000]); //remove the notification after timeout

			return () => {
				clearTimeout(timer);
			};
		}
	}, [uploadSuccess, uploadFailure]);

	const handleFileChange = (e) => {
		//Set target file
		setSelectedFile(e.target.files[0]);
		//Set name for file input
		if (e.target.files[0]?.name) {
			setSelectedFileName(e.target.files[0].name);
			setShowModal(true);
		} else {
			setSelectedFileName('');
		}
	};

	//Handle the upload of the file, this may be called from the FileUploadModal if set to customize upload info
	const handleUpload = (form = null) => {
		if (selectedFile) {
			let formData = new FormData();
			formData.append('fileToUpload', selectedFile);
			formData.append('submit', 1);
			//Selectively append the userID of the selected user for admin access upload
			if (selectedUser) {
				formData.append('userID', selectedUser._id);
			}
			if (form) {
				// Received additional data from FileUploadModal
				const keys = Object.keys(form);
				keys.forEach((key) => {
					formData.append(key, form[key]);
				});
			}
			php
				.post('/upload.php', formData)
				.then((res) => {
					if (res.status === 200) {
						setUploadSuccess(true);
						fileRef.current.value = null;
					}
				})
				.catch((err) => {
					setUploadFailure(true);
				});
		} else {
			fileRef.current.click();
		}
	};

	return (
		<>
			<Form.Group>
				<InputGroup>
					<InputGroup.Text>
						<FontAwesomeIcon icon={faUpload} />
					</InputGroup.Text>
					<input
						ref={fileRef}
						type="file"
						name="file"
						onChange={handleFileChange}
						style={{ visibility: 'hidden', width: '0px' }}
						accept=".pdf, .jpg, .jpeg, .png, .doc, .docx, .txt, .xls, .xlsx"
					/>
					<FormControl
						type="text"
						onClick={() => fileRef.current.click()}
						value={selectedFileName}
						placeholder="Choose a file."
						readOnly
					/>
					<Button
						type="button"
						variant="primary"
						onClick={() => {
							useModal ? setShowModal() : handleUpload();
						}}
					>
						Upload
					</Button>
				</InputGroup>
				{uploadSuccess && <Form.Text>File uploaded.</Form.Text>}{' '}
				{uploadFailure && <Form.Text>File uploaded.</Form.Text>}
			</Form.Group>
			<FileUploadModal
				showModal={showModal}
				setShowModal={setShowModal}
				file={selectedFile}
				handleUpload={handleUpload}
			/>
		</>
	);
}

export default FileUpload;
